import React from "react";

import { Ptag } from "components/core/fonts";
import { BenefitCardWrapper, Header } from "./styles";

const BenefitCard = ({ detail }) => {
  return (
    <BenefitCardWrapper>
      <Header>
        <img src={detail.icon_url} width="36px" />
        <Ptag fontSize="16px" fontWeight="600" color="#436AB2" marginLeft="1rem">
          {detail.heading}
        </Ptag>
      </Header>
      <div style={{marginTop: '1.4rem'}}>
        <Ptag fontSize="14px" marginTop="5px" letterHeight="20px">
          {detail.employer_sub_heading}
        </Ptag>
      </div>
    </BenefitCardWrapper>
  );
};

export default BenefitCard;
